import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../helpers/request';

const errorMessage = 'При добавлении вложения произошла ошибка';

const mutationFn = ({ addressId, commentId, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('commentId', commentId);

  return request.post(
    `/HousingStock/address/${addressId}/comment_v2/attachment`,
    formData,
    errorMessage,
    'Error'
  );
};

const useAddFlatCommentAttachment = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') return;

      if (data.success === false) {
        message.error(data.message || errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};

export default useAddFlatCommentAttachment;
